import React, { useMemo, useState } from "react"
import { Button, Col, Input, Label, Row } from "reactstrap"

const ReportColumnSelector = ({
  columns = [],
  onToggle = () => {},
  onReorder = () => {},
}) => {
  const [dragIndex, setDragIndex] = useState(null)
  const [dragOverIndex, setDragOverIndex] = useState(null)

  const toggleableColumns = useMemo(
    () => columns.filter(col => !col.required),
    [columns]
  )

  const allSelected = useMemo(
    () => toggleableColumns.every(col => col.visible),
    [toggleableColumns]
  )

  if (!columns?.length) return null

  const handleToggleAll = () => {
    const newState = !allSelected
    toggleableColumns.forEach(col => {
      if (col.visible !== newState) {
        onToggle(col.key)
      }
    })
  }

  const handleDragStart = (e, index) => {
    setDragIndex(index)
    e.dataTransfer.effectAllowed = "move"
    e.dataTransfer.setData("text/plain", index.toString())
  }

  const handleDragOver = (e, index) => {
    e.preventDefault()
    e.dataTransfer.dropEffect = "move"
    setDragOverIndex(index)
  }

  const handleDragLeave = () => {
    setDragOverIndex(null)
  }

  const handleDrop = (e, index) => {
    e.preventDefault()
    if (dragIndex !== null && dragIndex !== index) {
      onReorder(columns[dragIndex].key, index)
    }
    setDragIndex(null)
    setDragOverIndex(null)
  }

  const handleDragEnd = () => {
    setDragIndex(null)
    setDragOverIndex(null)
  }

  return (
    <div className="mb-3 border-top pt-3">
      <div className="d-flex align-items-center gap-2 mb-2">
        <Label className="form-label fw-semibold mb-0">Columns</Label>
        <Button
          color="primary"
          outline
          size="sm"
          onClick={handleToggleAll}
          className="py-0 px-2"
          style={{ fontSize: "0.75rem" }}
        >
          {allSelected ? "Deselect All" : "Select All"}
        </Button>
      </div>
      <p className="text-muted small mb-2">Drag columns to reorder</p>
      <Row>
        {columns.map((column, index) => {
          const isDragging = dragIndex === index
          const isDragOver = dragOverIndex === index && dragIndex !== index

          return (
            <Col md={4} lg={3} key={column.key} className="mb-2">
              <div
                draggable
                onDragStart={e => handleDragStart(e, index)}
                onDragOver={e => handleDragOver(e, index)}
                onDragLeave={handleDragLeave}
                onDrop={e => handleDrop(e, index)}
                onDragEnd={handleDragEnd}
                className={`d-flex align-items-center gap-1 p-1 rounded ${isDragging ? "opacity-50" : ""} ${isDragOver ? "bg-light border border-primary" : ""}`}
                style={{ cursor: "grab", transition: "all 0.15s ease", userSelect: "none" }}
              >
                <i className="bx bx-grip-vertical text-muted" style={{ cursor: "grab", fontSize: "1rem" }} />
                <div className="form-check" style={{ minWidth: 0 }}>
                  <Input
                    type="checkbox"
                    className="form-check-input"
                    id={`report-column-${column.key}`}
                    checked={!!column.visible}
                    disabled={!!column.required}
                    onChange={() => onToggle(column.key)}
                  />
                  <Label
                    className="form-check-label text-truncate"
                    htmlFor={`report-column-${column.key}`}
                    style={{ maxWidth: "180px" }}
                  >
                    {column.label}
                  </Label>
                </div>
              </div>
            </Col>
          )
        })}
      </Row>
    </div>
  )
}

export default ReportColumnSelector